const EN = {
  common: {
    email: 'Email Address',
    password: 'Password',
    login: 'Log-in',
    signUp: 'Join in',
    name: 'Your name',
    nickname: 'Nickname',
    birthYear: 'Birth(Year)',
    sex: 'Sex',
    edu: 'Education',
    education: {
      middle: 'Junior High School',
      high: 'High School',
      college: 'Undergraduate – AA Degree',
      university: 'Undergraduate – BA, BS Degree',
      graduate: 'Graduate school',
      attending: 'Attending school',
    },
    confirm: 'Ok',
    cancel: 'Cancel',
    close: 'Close',
  },
  error: {
    title: 'Something went wrong!',
    undefined: 'Please contact the Administrator.',
    notEnoughQuest: 'One person did not solve the question.',
    invalid: {
      email: 'Incorrect email address.',
      duplicateEmail: 'Email address already in use.',
      password: 'Password must be at least 8 characters or more',
      nickname: 'Please enter your valid nickname.',
      name: 'Please enter your full name.',
      birth: 'Please select the your birth.',
      sex: 'Please select the your sex.',
      education: 'Please select the your education.',
      duplicateNickname: 'This nickname is already using.',
      tag: 'Please select the category of your occupation.',
      auth: 'Please check your ID or password.',
      emoji: 'You can not enter emoticons.',
      clientId: 'Invalid ID.',
    },
    trackingProtection: `
      현재 접속하신 브라우저에선<br>
      서비스 일부 기능에<br>
      제한이 있을 수 있습니다.<br>
      쾌적한 TEAManity 이용을 위해<br>
      다른 브라우저를 이용하여<br>
      주시기 바랍니다.`,
    snsAuthFailed: 'Authentication failed.',
    consentProvideEmail: 'You must agree to provide email information.',
    isNotTestPeriod: 'This is not a test period.',
    notFound: {
      title: '404 Not Found',
      message: 'Oops! That page couldn\'t be found.',
    },
    tooLongGroupName: 'Group name cannot exceed 20 characters.',
  },
  intro: {
    description1: `<span>
      Welcome to TEAManity<br />
      How much do you know about yourself?<br />
      This app is to help you understand your true identity;<br />
      who you really are, and why you think/act the way you’ve been.<br />
      Ultimately, this app is to explain your innate potentials and<br />
      suggest most suitable careers that match your character.</span>`,
    description2: `<span>
      Finding the right partner has never been easier.<br />
      As this app reveals your strengths and weaknesses,<br />
      it can guide you to the matching person<br />
      who can reinforce your weaknesses & boost your strengths.</span>`,
    description3: `<span>
      And, most of all, with this powerful app,<br />
      you can build the best team that you’ve dreamed of<br />
      with people next door or across the world, or<br />
      you can evaluate your current team and find out<br />
      how to bring the best out of each member.<br />
      So, what are you waiting for? let’s Team Up Now!</span>`,
    next: 'Next',
    start: 'Start',
  },
  acc: {
    login: {
      title: 'Silicon Valley Teaming Network <br> The Ultimate Solution for Creating Your Own Team',
      signUpByEmail: 'Join in with your email address',
      findPassWord: 'Forgot Password?',
      curAccountLogin: 'Log-in with existing account',
      terms: '<div>By clicking below, I agree to <router-link to="/terms/service">the Terms of Use</router-link> and have read and consent <router-link to="/terms/privacy">Privacy Statement</router-link></div>',
    },
    signUp: {
      occupation: 'Occupation (can choose multiple)',
      necessary: '* required fields',
      pwHolder: 'Password (minimum 8 characters)',
      sex: {
        man: 'Man',
        woman: 'Woman',
      },
      sns: {
        title: 'Enter Personal Information',
        facebook: 'Log in with your Facebook account',
        kakao: 'Log in with your Kakao account',
        naver: 'Log in with Naver',
        idRequired: 'You may signup only at its homepage.',
      },
      terms: {
        title: 'Terms agreement process',
        service: 'Service Terms',
        privacy: 'Privacy Terms',
        checkbox: 'I Agree. <span>(Required)</span>',
        modal: 'You should agree on the terms.',
      },
    },
    delete: {
      header: 'Terminate my account',
      title: 'Re-confirm your Password',
      content: 'Please re-enter your password<br>to confirm account termination.',
      comment: 'Once you terminate your account, <br>you may not be able to join again using the same ID within next 3 months',
      placeholder: 'Password',
      button: 'Leave TEAManity',
      modalBody: 'Password Incorrect',
      done: {
        title: 'Account Termination Completed',
        content1: 'Your account has been successfully deleted.',
        content2: 'Thank you for having been a valuable member of our TEAManity.<br>We hope you to join us again in near future.',
        button: 'Confirm',
      },
    },
    detail: {
      header: 'My Account',
      headerLeft: 'Cancel',
      headerRight: 'Complete',
      name: 'Name',
      nickname: 'Nickname',
      email: 'Email Address',
      birth: 'Date of Birth',
      education: 'Last School Completed',
      jobs: 'Type of Occupation',
      delete: 'Terminate my Account',
      completed: 'Profile Update Completed',
    },
    done: {
      content: 'Congratulation!<br>Now you have full access to our TEAManity',
      button: 'Start',
    },
    findPw: {
      header: 'Find Password',
      content: 'TEAManity<br>The Ultimate Solution for Creating Your Own Team',
      holder: 'E-mail Address',
      button: 'Link to resetting your password has been sent to you via email.',
      result: 'Email sent.',
    },
  },
  myMenu: {
    editProfile: 'Edit your profile',
    myReport: 'My Report',
    myRole: 'My role',
    language: 'Set Language',
    customerCenter: 'Customer Center',
    notice: 'Notice',
    faq: 'FAQ',
    contactUs: 'Contact Us',
    logout: 'Log-out',
    logoutBody: 'Do you wish to log out?',
    terms: '<div>View <router-link to="/terms/service">Privacy Statement</router-link> and <router-link to="/terms/privacy">Terms of Use</router-link></div>',
    modalHeader: 'You have not completed your test yet.',
    modalBody: 'You may review your result once you complete the test.<br>Resume the Test?',
    anonymous: 'Anonymous',
    notification: 'Notification',
  },
  match: {
    listHeader: 'Matched List',
    friend: 'Friend',
    group: 'Group',
    resultHeader: 'Matching Compatibility',
    name: 'Name',
    nickname: 'Nickname',
    email: 'Email Address',
    birth: 'Date of Birth',
    education: 'Last School Completed',
    jobs: 'Type of Occupation',
    more: 'more',
    spreader: '열정적인 \'전파자\'',
    stargazer: '창의적인 \'몽상가\'',
    structuralDesigner: '엄격한 \'구조설계자\'',
    productPlanner: '현실적인 \'상품기획자\'',
    expert: '냉철한 \'독설가\'',
    executive: '완벽한 \'실행가\'',
    qr: {
      header: 'My QR Code',
      message1: 'Use the QR code below<br>to add friends to your list.',
      message2: 'You can check the compatibility rate<br>by scanning the QR code above.',
      message3: 'Use the QR code below<br>to invite friends to your group.',
      button: 'Scan QR Code',
    },
    qrScan: {
      header: 'QR Code Scan',
      message: 'When you scan the QR Code of others<br>it will automatically be added to your friend list.',
    },
    makeGroupPlaceholder: 'Please enter group name',
    inviteMember: 'Invite member',
    myFriend: 'My friend',
    expelMember: 'Expelling members',
    delegationLeader: 'Delegation of group leader',
    addGroupDone: 'Added to group',
  },
  report: {
    mine: 'My Report',
    roleHeader: 'My Role',
    title: 'Role Matching Compatibilities',
    content: 'You can view the ‘Role Matching Compatibility’ score. The higher the score, the better match with the Role.',
    ideation: {
      short: 'Generator',
      title: 'Idea Generator',
      content: 'Ability to generate new ideas or plan a new concept.  It is likely that right side of the brain oriented people have more creativity, enabling them to come up with new ideas and different perspective.',
    },
    multiplier: {
      short: ' Advocate',
      title: 'Social Advocate',
      content: 'Ability to share ideas and spread the ideas with others in the organization. It is likely that people with high level of sociality can quickly adapt to new ideas and spread them around fast.',
    },
    solution: {
      short: 'Organizer',
      title: 'System Organizer',
      content: 'Ability to tune and structuralize initial ideas, and further, to generate solutions for the shortcoming of the ideas. It is likely that Left side of the brain oriented people with sequential thinking ability can structuralize new ideas more easily.',
    },
    judgement: {
      short: 'Coordinator',
      title: 'Practical Coordinator',
      content: 'Ability to judge the practicality of new ideas and set directions accordingly.  It is likely that right side of the brain oriented people with intuitive ability can make better judgment on new ideas.',
    },
    execution: {
      short: 'Executor ',
      title: 'Coolheaded Executor',
      content: 'Ability to execute new ideas and follow through with a plan. No matter how brilliant an idea is, it will hardly materialize without strong will of execution. It is likely that people with perfectionistic character possess strong execution power.',
    },
    critic: {
      short: 'Critics ',
      title: 'Skeptical Critics',
      content: 'Ability to critically assess the problems of an idea, and even point out possible risk in the future without bias. It is likely that right side of the brain oriented people with logical mindset can assess an idea and generate an honest opinion on the idea.',
    },
    veryGood: 'Best',
    good: 'Good',
    soso: 'Normal',
    bad: 'Bad',
    veryBad: 'Worst',
  },
  tabMenu: {
    home: 'Home',
    report: 'My Report',
    friend: 'Match',
    matching: 'Matched List',
  },
  friends: {
    title: 'Add Friends',
    kakao: 'Invite friends via Kakao',
    urlAdd: 'Invite Friends via URL',
    qr: 'My QR Code',
    groupQr: 'Group QR Code',
    qrScan: 'Scan QR Code',
    btnOK: 'OK',
    btnClose: 'Close',
    share: 'Share My Result',
    shareBtn: 'Share',
    facebook: 'Share with Facebook',
    url: 'Share with URL',
    urlCopy: 'Copy to clipboard',
  },
  test: {
    intro: {
      header: 'Start the Test',
      title: 'Team Composition / Role Test',
      content1: 'It takes approximately 15 minutes to complete the test, and you cannot undo the answer once have chosen.',
      content2: 'Please answer the questions honestly regardless of your preferences.',
      content3: 'You can edit only your last answer.',
      button: 'Start the test',
    },
    question: {
      header: 'Test',
      headerRight: 'Save the test',
      stronglyAgree: 'very likely',
      agree: 'likely',
      disagree: 'Unlikely',
      stronglyDisagree: 'very Unlikely',
      // minimum: 'You need to answer at least 6 questions in order to save the test',
    },
    done: {
      header: 'Test Completed',
      content: 'You have successfully competed the test',
      button: 'Go to main page',
    },
  },
  mc6: {
    info: 'Check \'MC6\' after the test.',
    friends: {
      done: 'Completed adding friends',
    },
  },
  terms: {
    title: {
      privacy: 'Privacy Terms',
      service: 'Service Terms',
    },
  },
  share: {
    title: '[TEAManity]',
    desc: 'Use TEAManity to find out about your personality and find out the match rate with the people around you.',
    addDesc: 'Find my hidden potential with brain aptitude tests!',
    imgUrl: 'https://api.teamanity.app:11604/files/meta/mc6-share.jpg',
  },
  matchManage: {
    title: 'Manage matching list',
    inviteFriend: 'Invite friend',
    makeGroup: 'Make group',
  },
  groupManage: {
    title: 'Group management',
    invite: 'Invite member',
    expel: 'Expel',
    delegation: 'Delegation',
    secession: 'Secession',
    secessionMsg: 'Are you sure you want to leave the group?',
  },
};

export default EN;



// WEBPACK FOOTER //
// ./src/constants/i18n/en.js